module.exports = __webpack_public_path__ + "img/resource_vortex_site.c180adff.png";